import React, { useState, useEffect } from "react";
import "./styles.scss";
import Layout from "../../components/Layout/Layout";
import { Link, useHistory } from "react-router-dom";
import ViewMore from "../../components/ViewMore/ViewMore";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchCategory } from "../../redux/actions/category";
import { fetchSearch } from "../../redux/actions/products";

import truncate from "../../utils/truncate";
import numberToComma from "../../utils/numberToComma";

import CardSmall from "../../components/CardSmall/CardSmall";

const Search = (props) => {
  const {
    match: { params },
  } = props;
  const history = useHistory();
  const [products, setProduct] = useState([]);
  const [category, setCategory] = useState([]);
  const [pageCount, setPage] = useState(10);
  const [check, setCheck] = useState(false);
  const [catKey, setCatKey] = useState(0);
  const [search, setSearch] = useState({ text: params.item });

  function viewMore() {
    // props.fetchCategoryProduct(params.category, pageCount);
    setPage(pageCount + 10);
  }

  function handleChange(e) {
    e.preventDefault();
    setCheck(true);
    props.fetchSearch(search);
  }

  function changeOrder(e) {
    e.target.value === ("oldest" || "latest") &&
      setSearch({
        ...search,
        order: "createdAt",
        orderVal: e.target.value === "oldest" ? "ASC" : "DESC",
      });
    e.target.value === ("lowest_p" || "highest_p") &&
      setSearch({
        ...search,
        order: "net_price",
        orderVal: e.target.value === "lowest_p" ? "ASC" : "DESC",
      });
    e.target.value === ("lowest_r" || "highest_r") &&
      setSearch({
        ...search,
        order: "rating",
        orderVal: e.target.value === "lowest_r" ? "ASC" : "DESC",
      });
  }

  function handleCategory(e) {
    setSearch({ ...search, catId: category[e.target.value].id });
    setCatKey(e.target.value);
  }

  function handleSubCat(e) {
    setSearch({ ...search, subCat: e.target.value });
  }

  useEffect(() => {
    props.fetchSearch(search);
    props.fetchCategory();
  }, []);

  useEffect(() => {
    if (props.search.search.data) {
      setProduct(props.search.search.data.product);
      //setSearch({ ...search, text: "" });
      setCheck(false);
    }
  }, [props.search.search.data]);

  useEffect(() => {
    if (props.search.errors.errors) {
      //setProduct(props.search.search.data.product);
      //setSearch({...search, text:""});
      setCheck(false);
    }
  }, [props.search.errors.errors]);

  useEffect(() => {
    if (props.category.category.data) {
      setCategory(props.category.category.data.store.categories);
    }
  }, [props.category.category.data]);

  return (
    <Layout>
      <section className="category-section">
        <div className="bread-crumbs">
          <Link to="/">Home</Link> <i class="fa fa-caret-right pl-2 pr-2"></i>
          <p className="title-page">Search</p>
        </div>
        <div className="row">
          <div className="col-md-12 row justify-content-center">
            <input
              type="text"
              placeholder="search"
              value={search.text}
              onChange={(e) => {setSearch({ ...search, text: e.target.value }); params.item=e.target.value }}
              className="form-control col-md-6 ml-2 mr-2 mb-2"
            />
            <button
              className="btn btn-outline-secondary ml-2"
              onClick={handleChange}
            >
              {!check ? (
                "Search"
              ) : (
                <div>
                  <span
                    className="spinner-border spinner-border-sm mr-1"
                    role="status"
                    aria-hidden="true"
                    disabled={check}
                  ></span>
                  Searching...
                </div>
              )}
            </button>
          </div>
          <div className="col-md-2">
            <h6 className="mb-2">Filter search</h6>
            <div>
              <label htmlFor="order">Category</label>
              <div className="input-group mb-3 ">
                <select
                  className="custom-select"
                  id="inputGroupSelect01"
                  value={search.catId}
                  onChange={(e) =>
                    setSearch({ ...search, catId: e.target.value })
                  }
                >
                  <option value="" selected>
                    select categories
                  </option>
                  {category.map((index, i) => {
                    return (
                      <option key={i} value={index.id}>
                        {index.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            {/* <div>
              <label htmlFor="">Category</label>
              <div className="input-group mb-3 ">
                <select
                  className="custom-select"
                  id="inputGroupSelect01"
                  value={catKey}
                  onChange={handleCategory}
                >
                  {category.map((index, i) => {
                    return (
                      <option key={i} value={i}>
                        {index.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div>
              <label htmlFor="">Sub Category</label>
              <div className="input-group mb-3 ">
                <select
                  className="custom-select"
                  id="inputGroupSelect01"
                  onChange={handleSubCat}
                >
                  <option value=" " selected>Select Sub Categories...</option>
                  {(
                    (category.length > 1 && category[catKey].subCategories) ||
                    []
                  ).map((name, i) => {
                    return (
                      <option key={i} value={name}>
                        {name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div> */}
            <div className="form-group mb-3">
              <label htmlFor="">Minimum price</label>
              <input
                type="number"
                name="min"
                className="form-control"
                placeholder="0"
                value={search.min}
                onChange={(e) => setSearch({ ...search, min: e.target.value })}
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="">Maximum price</label>
              <input
                type="number"
                name="max"
                className="form-control"
                placeholder="1000000"
                value={search.max}
                onChange={(e) => setSearch({ ...search, max: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="order">Order by</label>
              <div className="input-group mb-3 ">
                <select
                  className="custom-select"
                  id="inputGroupSelect01"
                  //value={e.target.value}
                  onChange={changeOrder}
                >
                  <option value="latest" selected>
                    Latest
                  </option>
                  <option value="oldest">Oldest </option>
                  <option value="lowest_p">Lowest price </option>
                  <option value="highest_p">Highest price </option>
                  <option value="lowest_r">Lowest rating </option>
                  <option value="highest_r">Highest rating </option>
                </select>
              </div>
            </div>
            <button
              className="btn btn-outline-info btn-block"
              onClick={handleChange}
            >
              {!check ? (
                "Filter"
              ) : (
                <div>
                  <span
                    className="spinner-border spinner-border-sm mr-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Filtering...
                </div>
              )}
            </button>
          </div>
          <div className="col-md-10">
            {
              <div className="row">
                {products.map((item, i) => {
                  return (
                    <div className="category-items" key={i}>
                      <CardSmall
                        photo={item.images[0]}
                        item={truncate(item.product_name, 20)}
                        price={numberToComma(item.net_price)}
                        desc={truncate(item.description, 25)}
                        // like={item.favourites.length > 0 ? true : false}
                        soldout={item.stock_limit < 1 ? true : false}
                        oldPrice={item.price}
                        discount={item.discount}
                        // favourite={() => {
                        //   if (item.favourites.length > 0) {
                        //     removeFav(item.id);
                        //   } else {
                        //     saveItem(item.id);
                        //   }
                        // }}
                        action={() => history.push(`/product/${item.id}`)}
                      />
                    </div>
                  );
                })}
              </div>
            }
          </div>
        </div>

        <ViewMore viewHandler={viewMore} />
      </section>
    </Layout>
  );
};

Search.propTypes = {
  search: PropTypes.object.isRequired,
  fetchSearch: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  search: state.search,
  category: state.category,
});

const pageActions = { fetchSearch, fetchCategory };
export default connect(mapStateToProps, pageActions)(Search);
